import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      boxSizing: "border-box",
      fontFamily: theme.typography.fontFamily,
    },

    summaryBar: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
      minHeight: "143px",
      padding: "16px",
      gap: "10px",
      borderRadius: "4px",
      opacity: 1,
      backgroundColor: theme.palette.common.white,
      boxSizing: "border-box",
    },

    summaryTitle: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      leadingTrim: "cap-height",
      color: theme.palette.secondary.main,
      textAlign: "right",
      width: "100%",
      margin: 0,
    },

    fieldsRow: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      flex: 1,
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    imageCell: {
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    },

    vehicleImage: {
      width: "63px",
      height: "63px",
      borderRadius: "4px",
      objectFit: "cover",
      flexShrink: 0,
    },

    field: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      flex: "1 1 0",
      minWidth: 0,
    },

    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "140%",
      color: theme.palette.text.primary,
      textAlign: "right",
      whiteSpace: "nowrap",
    },

    valueRow: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      gap: "4px",
    },

    value: {
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
      whiteSpace: "nowrap",
    },

    chevron: {
      fontSize: "18px !important",
      color: theme.palette.text.primary,
    },

    metricsCard: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      padding: 24,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
    },

    metricsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      direction: "rtl",
      gap: 16,
      width: "100%",
    },

    metric: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0,
      width: "100%",
    },

    metricLabel: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: "12px !important",
      fontWeight: "400 !important",
      lineHeight: "140% !important",
      color: `${theme.palette.text.primary} !important`,
      textAlign: "right",
      whiteSpace: "nowrap",
    },

    metricValue: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: "14px !important",
      fontWeight: "600 !important",
      lineHeight: "140% !important",
      color: `${theme.palette.secondary.main} !important`,
      textAlign: "right",
      whiteSpace: "nowrap",
    },

    profitText: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: "12px !important",
      fontWeight: "400 !important",
      lineHeight: "140% !important",
      color: `${theme.palette.text.secondary} !important`,
      textAlign: "right",
      marginTop: "2px !important",
    },

    sectionsCard: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      padding: 24,
      boxSizing: "border-box",
    },

    formSection: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      width: "100%",
    },

    sectionHeader: {
      borderTop: `1px solid ${theme.palette.divider}`,
      paddingTop: 16,
      display: "flex",
      justifyContent: "flex-start",
      direction: "rtl",
      width: "100%",
    },

    sectionHeaderPlain: {
      display: "flex",
      justifyContent: "flex-start",
      direction: "rtl",
      width: "100%",
    },

    sectionTitle: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      textAlign: "right",
    },

    grid4: {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      direction: "rtl",
      gap: 16,
      width: "100%",
    },

    grid6: {
      display: "grid",
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      direction: "rtl",
      gap: 16,
      width: "100%",
    },

    grid3: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      direction: "rtl",
      gap: 16,
      width: "100%",
    },

    grid2: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      direction: "rtl",
      gap: 16,
      width: "100%",
    },

    floorGrid: {
      display: "flex",
      flexDirection: "row",
      direction: "rtl",
      alignItems: "flex-start",
      gap: 16,
      width: "100%",
    },

    fieldMetric: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0,
      width: "100%",
    },

    fieldMetricLabel: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: "140%",
      color: theme.palette.text.primary,
      textAlign: "right",
    },

    fieldMetricValue: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
    },

    inputCard: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      padding: 24,
      boxSizing: "border-box",
    },

    numberedSectionTitle: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 10,
      direction: "rtl",
      width: "100%",
    },

    sectionNumber: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 24,
      height: 24,
      gap: 10,
      opacity: 1,
      transform: "rotate(0deg)",
      borderRadius: 50,
      flexShrink: 0,
      backgroundColor: theme.palette.grey[400],
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
    },

    sectionNumberLabel: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      textAlign: "right",
    },

    formField: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      minWidth: 0,
      width: "100%",
    },

    formFieldCompact: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 200,
      minWidth: 200,
      maxWidth: 200,
      flexShrink: 0,
    },

    formFieldGrow: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      flex: 1,
      minWidth: 0,
    },

    formFieldStepperCompact: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      flexShrink: 0,
    },

    formFieldStepperHeight: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 110,
      minWidth: 110,
      maxWidth: 110,
      flexShrink: 0,
    },

    formFieldStepperQuantity: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 90,
      minWidth: 90,
      maxWidth: 90,
      flexShrink: 0,
    },

    formFieldStepperShort: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 80,
      minWidth: 80,
      maxWidth: 80,
      flexShrink: 0,
    },

    formFieldStepperNarrow: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: 100,
      minWidth: 100,
      maxWidth: 100,
      flexShrink: 0,
    },

    formLabel: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: "140%",
      color: theme.palette.text.primary,
      textAlign: "right",
      width: "100%",
      margin: 0,
    },

    stepperBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: "100%",
      minWidth: 0,
      overflow: "hidden",
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperBoxCompact: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: 150,
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperBoxHeight: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: 110,
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperBoxQuantity: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: 90,
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperBoxShort: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: 80,
      minWidth: 80,
      maxWidth: 80,
      flexShrink: 0,
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperBoxNarrow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      direction: "ltr",
      width: 100,
      height: 48,
      gap: 10,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    stepperArrows: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: 24,
      height: 24,
      color: theme.palette.text.primary,
    },

    stepperIcon: {
      display: "block",
      width: 24,
      height: 24,
      color: theme.palette.text.primary,
    },

    stepperHitUp: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "50%",
      cursor: "pointer",
    },

    stepperHitDown: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "50%",
      cursor: "pointer",
    },

    stepperValue: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    formSelect: {
      direction: "rtl",
      width: "100%",
      height: 48,
      gap: 10,
      opacity: 1,
      transform: "rotate(0deg)",
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.secondary.main,
      boxSizing: "border-box",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        height: 48,
        minHeight: "48px !important",
        paddingTop: "12px !important",
        paddingRight: "16px !important",
        paddingBottom: "12px !important",
        paddingLeft: "38px !important",
        direction: "rtl",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.secondary.main,
      },
      "& .MuiSelect-icon": {
        left: "8px !important",
        right: "auto !important",
        top: "50%",
        transform: "translateY(-50%) rotate(0deg)",
      },
    },

    formSelectControl: {
      width: "100%",
      minWidth: 0,
      margin: 0,
    },

    formSelectControlCompact: {
      width: 200,
    },

    formSelectCompact: {
      direction: "rtl",
      width: 200,
      height: 48,
      gap: 10,
      opacity: 1,
      transform: "rotate(0deg)",
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.secondary.main,
      boxSizing: "border-box",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        height: 48,
        minHeight: "48px !important",
        paddingTop: "12px !important",
        paddingRight: "16px !important",
        paddingBottom: "12px !important",
        paddingLeft: "38px !important",
        direction: "rtl",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.secondary.main,
      },
      "& .MuiSelect-icon": {
        left: "8px !important",
        right: "auto !important",
        top: "50%",
        transform: "translateY(-50%) rotate(0deg)",
      },
    },

    selectValue: {
      display: "block",
      width: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    selectMenuPaper: {
      maxHeight: 240,
      marginTop: 4,
      borderRadius: 4,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: "0 4px 24px rgba(37, 56, 88, 0.12)",
      boxSizing: "border-box",
      overflow: "hidden",
    },

    selectMenuList: {
      maxHeight: 232,
      padding: 4,
      boxSizing: "border-box",
      overflowY: "auto",
      overflowX: "hidden",
    },

    checkboxRow: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
    },

    checkboxBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 10,
      width: 200,
      height: 48,
      paddingTop: 12,
      paddingRight: 16,
      paddingBottom: 12,
      paddingLeft: 8,
      borderRadius: 4,
      opacity: 1,
      transform: "rotate(0deg)",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
    },

    checkboxLabel: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
    },

    optionSectionContent: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      width: "100%",
      direction: "rtl",
    },

    optionCardRow: {
      display: "grid",
      gap: 10,
      width: "100%",
      direction: "rtl",
      alignItems: "stretch",
      "& > *": {
        height: "100%",
        minWidth: 0,
      },
    },

    storageRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      gap: 10,
      width: "100%",
      direction: "rtl",
      "& > *:last-child": {
        flex: 1,
        minWidth: 0,
      },
    },

    storageQuantityRow: {
      display: "flex",
      flexDirection: "row",
      gap: 4,
      direction: "rtl",
      flexShrink: 0,
      "& > *": {
        width: 132,
        height: 138,
        gap: 4,
        opacity: 1,
        transform: "rotate(0deg)",
        boxSizing: "border-box",
        flexShrink: 0,
      },
    },

    optionCard: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      boxSizing: "border-box",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      padding: "12px 16px",
      minWidth: 0,
      height: "100%",
      direction: "rtl",
      backgroundColor: theme.palette.background.paper,
    },

    optionCardBody: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      width: "100%",
      minWidth: 0,
    },

    optionCardBodyAligned: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      flex: 1,
      width: "100%",
      minWidth: 0,
      "& > * > .MuiTypography-root": {
        minHeight: "calc(1.4em * 2)",
      },
    },

    optionCardActive: {
      backgroundColor: theme.palette.info.light,
    },

    optionCardDivider: {
      width: "100%",
      height: 1,
      backgroundColor: theme.palette.divider,
    },

    optionCheckboxRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 8,
      width: "100%",
      direction: "rtl",
      "& .MuiCheckbox-root": {
        flexShrink: 0,
      },
    },

    optionCheckboxLabel: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
      direction: "rtl",
    },

    optionCheckboxTitle: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "140%",
      color: theme.palette.secondary.main,
      textAlign: "right",
      direction: "rtl",
      flex: 1,
      minWidth: 0,
    },

    optionFieldsRow: {
      display: "flex",
      gap: 10,
      alignItems: "flex-start",
      width: "100%",
      direction: "rtl",
      minWidth: 0,
    },

    optionFieldsRowLtr: {
      direction: "ltr",
    },

    optionNoteColumn: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      flex: 1,
      minWidth: 0,
      direction: "rtl",
    },

    noteInput: {
      direction: "rtl",
      margin: 0,
      width: "100%",
      "& .MuiOutlinedInput-root": {
        margin: 0,
        height: 48,
        boxSizing: "border-box",
        borderRadius: 4,
        backgroundColor: theme.palette.background.paper,
        fontFamily: theme.typography.fontFamily,
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.secondary.main,
        "& fieldset": {
          borderColor: theme.palette.divider,
          borderWidth: 1,
        },
        "&:hover fieldset": {
          borderColor: theme.palette.divider,
        },
        "&.Mui-focused fieldset": {
          borderColor: theme.palette.primary.main,
          borderWidth: 1,
        },
      },
      "& .MuiOutlinedInput-input": {
        padding: "12px 16px 12px 8px",
        height: "100%",
        boxSizing: "border-box",
        direction: "rtl",
        textAlign: "right",
        fontFamily: theme.typography.fontFamily,
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.secondary.main,
        "&::placeholder": {
          color: theme.palette.text.primary,
          opacity: 1,
        },
      },
    },

    tablesWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 24,
      width: "100%",
      direction: "rtl",
    },

    tableBlock: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      width: "100%",
      direction: "rtl",
    },

    tableHeaderRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      direction: "rtl",
      gap: 12,
    },

    tableTitle: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      textAlign: "right",
      direction: "rtl",
    },

    addRowButton: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      height: 42,
      minHeight: 42,
      boxSizing: "border-box",
      padding: "10px 16px",
      borderRadius: 4,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "140%",
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      },
      "& .MuiButton-startIcon": {
        margin: 0,
      },
      "& .MuiButton-endIcon": {
        margin: 0,
      },
    },

    quoteActions: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 12,
      width: "100%",
      direction: "ltr",
    },

    resetButton: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      width: 110,
      minWidth: 110,
      height: 42,
      minHeight: 42,
      boxSizing: "border-box",
      padding: "10px 16px",
      borderRadius: 4,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "140%",
      textTransform: "none",
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.common.white,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.text.primary,
      boxShadow: "none",
      "&.MuiButton-outlined": {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.text.primary,
      },
      "&:hover": {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.text.primary,
        boxShadow: "none",
      },
    },

    table: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      border: `1px solid ${theme.palette.divider}`,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      overflow: "hidden",
      direction: "rtl",
    },

    tableHeadRow: {
      display: "grid",
      gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
      height: 52,
      minHeight: 52,
      boxSizing: "border-box",
      backgroundColor: theme.palette.grey[400],
      borderBottom: `1px solid ${theme.palette.divider}`,
      direction: "rtl",
    },

    tableBodyRow: {
      display: "grid",
      gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
      height: 52,
      minHeight: 52,
      boxSizing: "border-box",
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      direction: "rtl",
      "&:last-child": {
        borderBottom: "none",
      },
    },

    tableHeadRowBasket: {
      display: "grid",
      gridTemplateColumns: "48px 1fr 88px 2fr",
      height: 52,
      minHeight: 52,
      boxSizing: "border-box",
      backgroundColor: theme.palette.grey[400],
      borderBottom: `1px solid ${theme.palette.divider}`,
      direction: "rtl",
    },

    tableBodyRowBasket: {
      display: "grid",
      gridTemplateColumns: "48px 1fr 88px 2fr",
      height: 52,
      minHeight: 52,
      boxSizing: "border-box",
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      direction: "rtl",
      "&:last-child": {
        borderBottom: "none",
      },
    },

    tableHeadCell: {
      padding: "0 12px",
      height: "100%",
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.text.primary,
      textAlign: "right",
      direction: "rtl",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      minWidth: 0,
    },

    tableCell: {
      padding: "0 12px",
      minWidth: 0,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      direction: "rtl",
    },

    tableIndexCell: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      textAlign: "center",
      justifyContent: "center",
    },

    tableCellText: {
      width: "100%",
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      textAlign: "right",
      direction: "rtl",
      wordBreak: "break-word",
    },
  })
);
